import directus from "api/services/directus";
import { StrainListTileSections } from "custom-types/Directus";
import createDirectusImgixUrl from "utils/createDirectusImgixUrl";
import logError from "utils/logError";

const getStrainListTileSections = async (countryCode: string) => {
  const params = {
    fields:
      "*,section_one_tile_one_image.filename_disk,section_one_tile_two_image.filename_disk,section_one_tile_three_image.filename_disk,section_one_tile_four_image.filename_disk,section_one_tile_five_image.filename_disk,section_one_tile_six_image.filename_disk,section_two_tile_one_image.filename_disk,section_two_tile_two_image.filename_disk,section_two_tile_three_image.filename_disk,section_two_tile_four_image.filename_disk,section_two_tile_five_image.filename_disk,section_two_tile_six_image.filename_disk",
    "filter[status][_eq]": "published",
    "filter[targeting][country][_eq]": countryCode,
  };

  try {
    const { data = [] } = await directus.get<StrainListTileSections[]>(
      "strain_list_tile_sections",
      {
        params,
      },
    );

    const sections: StrainListTileSections<string | null>[] = data.map(
      (section) => ({
        ...section,
        section_one_tile_five_image: section.section_one_tile_five_image
          ? createDirectusImgixUrl(
              section.section_one_tile_five_image.filename_disk,
            )
          : null,
        section_one_tile_four_image: section.section_one_tile_four_image
          ? createDirectusImgixUrl(
              section.section_one_tile_four_image.filename_disk,
            )
          : null,
        section_one_tile_one_image: section.section_one_tile_one_image
          ? createDirectusImgixUrl(
              section.section_one_tile_one_image.filename_disk,
            )
          : null,
        section_one_tile_six_image: section.section_one_tile_six_image
          ? createDirectusImgixUrl(
              section.section_one_tile_six_image.filename_disk,
            )
          : null,
        section_one_tile_three_image: section.section_one_tile_three_image
          ? createDirectusImgixUrl(
              section.section_one_tile_three_image.filename_disk,
            )
          : null,
        section_one_tile_two_image: section.section_one_tile_two_image
          ? createDirectusImgixUrl(
              section.section_one_tile_two_image.filename_disk,
            )
          : null,
        section_two_tile_five_image: section.section_two_tile_five_image
          ? createDirectusImgixUrl(
              section.section_two_tile_five_image.filename_disk,
            )
          : null,
        section_two_tile_four_image: section.section_two_tile_four_image
          ? createDirectusImgixUrl(
              section.section_two_tile_four_image.filename_disk,
            )
          : null,
        section_two_tile_one_image: section.section_two_tile_one_image
          ? createDirectusImgixUrl(
              section.section_two_tile_one_image.filename_disk,
            )
          : null,
        section_two_tile_six_image: section.section_two_tile_six_image
          ? createDirectusImgixUrl(
              section.section_two_tile_six_image.filename_disk,
            )
          : null,
        section_two_tile_three_image: section.section_two_tile_three_image
          ? createDirectusImgixUrl(
              section.section_two_tile_three_image.filename_disk,
            )
          : null,
        section_two_tile_two_image: section.section_two_tile_two_image
          ? createDirectusImgixUrl(
              section.section_two_tile_two_image.filename_disk,
            )
          : null,
      }),
    );

    return sections;
  } catch (e) {
    logError(e.message, {
      functionName: "getStrainListTileSections",
      service: "directus",
      statusCode: e.statusCode,
    });

    return [];
  }
};

export default getStrainListTileSections;
